export default "__VITE_ASSET__BuOem1l7__"